
import React from "react";

// core components
import Navbar from "components/Navbars/Navbar.js";
import Footer from "components/Footers/Footer.js";

// Import Simple React Lightbox
import SimpleReactLightbox from "simple-react-lightbox";

// core components
import { SRLWrapper } from "simple-react-lightbox";

// Sections
import DevelopmentHeader from "./../components/Headers/DevelopmentHeader";
import DevelopmentChronology2018 from "../components/Development/SectionChronology2018";
import DevelopmentChronology2019 from "../components/Development/SectionChronology2019";
import DevelopmentChronology2020 from "../components/Development/SectionChronology2020";
import SectionChronologyCel from "../components/Development/SectionChronologyCel";
import SectionChronologyThanks from "./../components/Development/SectionChronologyThanks";

function Development() {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("profile-page");
    return function cleanup() {
      document.body.classList.remove("profile-page");
    };
  });

  // Create an object with the options that you want to use. The options are divided in 4 main objects. You don't need to define them all.
  const options = {
    settings: {
      overlayColor: "rgb(0, 0, 0, 0.9)",
    },
  };


  return (
    <>
      <Navbar />
      <DevelopmentHeader />
      <div className="main">
        <fieldset className="d-none d-lg-block d-xl-none d-xl-block">
          <SimpleReactLightbox >
            <SRLWrapper options={options}>
              <DevelopmentChronology2018 />
              <DevelopmentChronology2019 />
            </SRLWrapper>
            <DevelopmentChronology2020 />
          </SimpleReactLightbox >
        </fieldset>
        <SectionChronologyCel />
        <SectionChronologyThanks />
      </div>
      <Footer />
    </>
  );
}

export default Development;
